module.exports = __webpack_public_path__ + "img/smart_phone_01.a17265fb.png";